export { VMDetailsBase } from './vm-details-base';
export { VMDetailsAzure } from './vm-details-azure';
export { VMDetailsAWS } from './vm-details-aws';
